import CrossSellGalleryElementMetaData from '../CrossSellGalleryElement/CrossSellGalleryElementMetaData';

export default {
  type: 'editor.elements.MobileCrossSellGalleryElement',
  name: 'Cross Sell',
  icon: CrossSellGalleryElementMetaData.icon,
  order: 120
};
